import { render, staticRenderFns } from "./AddressSelector.vue?vue&type=template&id=3a4ef5f4&scoped=true&"
import script from "./AddressSelector.vue?vue&type=script&lang=js&"
export * from "./AddressSelector.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./AddressSelector.vue?vue&type=style&index=0&id=3a4ef5f4&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3a4ef5f4",
  null
  ,true
)

export default component.exports